module.exports = __webpack_public_path__ + "img/icon-new.28e28f1d.svg";